module.exports = __webpack_public_path__ + "img/model2.e8f6820f.gif";